export default __webpack_public_path__ + "static/media/BG_Page_02.571f2fe8.svg";